import { render, staticRenderFns } from "./GlobalConfigUpdateDialogExternalSource.vue?vue&type=template&id=681cf02c&scoped=true"
import script from "./GlobalConfigUpdateDialogExternalSource.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigUpdateDialogExternalSource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cf02c",
  null
  
)

export default component.exports